import Joi from 'joi';
import countries from '../../../Lib/Constants/countries';

export default {
  pageTitle: 'Buyer Questionnaire',
  cards: [
    {
      title: 'Vendor Review',
      fields: [
        {
          label: 'What is the advantage of adding this vendor?',
          name: 'whyNeedVendor',
          type: 'text',
          multiline: true,
          required: true,
        },
        {
          label: 'What INCO term has been agreed upon with the vendor?',
          name: 'incoterms',
          type: 'select',
          required: true,
          options: [
            { value: 'DDP', label: 'DDP' },
            { value: 'FCA', label: 'FCA' },
            { value: 'FOB', label: 'FOB' },
          ],
        },
        {
          label: 'Is this a one-time vendor?',
          name: 'oneTimeVendor',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Is this a seasonal vendor?',
          name: 'seasonalVendor',
          required: true,
          type: 'yes_no',
        },
        {
          cond: ({ seasonalVendor }) => seasonalVendor === 'yes',
          label: 'What categories?',
          name: 'seasonCategories',
          type: 'select',
          multiple: true,
          required: true,
          options: [
            { value: 'Halloween', label: 'Halloween' },
            { value: 'Swim', label: 'Swim' },
            { value: 'Outerwear', label: 'Outerwear' },
            { value: 'Lingerie', label: 'Lingerie' },
            { value: 'Sweaters', label: 'Sweaters' },
            { value: 'Tops', label: 'Tops' },
            { value: 'Bottoms', label: 'Bottoms' },
            { value: 'Accessories', label: 'Accessories' },
            { value: 'Denim', label: 'Denim' },
            { value: 'Shoes', label: 'Shoes' },
            { value: 'Dresses', label: 'Dresses' },
            { value: 'Active Wear', label: 'Active Wear' },
          ],
        },
        {
          label:
            'Has this relationship been approved by your department owner?',
          name: 'relationshipApproved',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ relationshipApproved }) => relationshipApproved === 'yes',
          label: 'Sponsor VP name : ',
          name: 'sponsorVPName',
          type: 'text',
          required: true,
        },
      ],
    },
    {
      title: 'Relationship History',
      fields: [
        {
          label:
            'Have you previously done business with this supplier or a related entity via Fashion Nova or a previously held role?',
          name: 'previouslyDoneBusiness',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ previouslyDoneBusiness }) =>
            previouslyDoneBusiness === 'yes',
          label:
            'Please explain historical interaction / relationship with this vendor.',
          name: 'historicalInteraction',
          type: 'text',
          multiline: true,
          required: true,
        },
        {
          cond: ({ previouslyDoneBusiness }) => previouslyDoneBusiness === 'no',
          label: 'Please explain how you came in contact with this vendor.',
          name: 'howCameInContact',
          type: 'text',
          multiline: true,
          required: true,
        },
        {
          label:
            'Have you previously done business with any principals or employees of this company, either at this company or any other company?',
          name: 'previouslyDoneBusinessWithPrincipals',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ previouslyDoneBusinessWithPrincipals }) =>
            previouslyDoneBusinessWithPrincipals === 'yes',
          label: 'Please explain.',
          name: 'previouslyDoneBusinessWithPrincipals.explain',
          multiline: true,
          type: 'text',
          required: true,
        },
        {
          cond: ({ previouslyDoneBusinessWithPrincipals }) =>
            previouslyDoneBusinessWithPrincipals === 'no',
          label: 'How did you come in contact with this supplier / vendor?',
          name: 'howComeInContact',
          type: 'text',
          multiline: true,
          required: true,
        },
        {
          label: 'Were you referred to this supplier / vendor by anyone?',
          name: 'referredByAnyone',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ referredByAnyone }) => referredByAnyone === 'yes',
          label: 'Please name the individual and their corresponding employer.',
          name: 'individualAndEmployer',
          type: 'text',
          multiline: true,
          required: true,
        },
      ],
    },
    {
      title: 'Proposed RelationShip',
      fields: [
        {
          label:
            'How much is expected spend with this proposed vendor (a year)?',
          name: 'expectedSpend',
          type: 'text',
          inputType: 'number',
          required: true,
          prefix: '$',
          specialValidation: Joi.number().required(),
        },
        {
          label:
            'Was there a future purchasing commitment in volume or units agreed with the vendor?',
          name: 'futurePurchasingCommitment',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ futurePurchasingCommitment }) =>
            futurePurchasingCommitment === 'yes',
          label: 'Please explain.',
          name: 'futurePurchasingCommitment.explain',
          type: 'text',
          multiline: true,
          required: true,
        },
        {
          label: 'Have you reviewed samples for workmanship/cost?',
          name: 'reviewedSamples',
          type: 'yes_no',
          required: true,
        },
      ],
    },
    {
      title: 'Intent to order',
      fields: [
        {
          label: 'Type of order',
          name: 'intentToOrderType',
          type: 'radios',
          options: [
            {
              value: 'new',
              label: 'New',
            },
            {
              value: 'counter',
              label: 'Counter',
            },
          ],
          required: true,
        },
        {
          cond: ({ intentToOrderType }) => intentToOrderType === 'new',
          label: 'How many styles do we intend to order?',
          name: 'newStylesCount',
          type: 'text',
          required: true,
          inputType: 'number',
          specialValidation: Joi.number().required(),
        },
        {
          cond: ({ intentToOrderType }) => intentToOrderType === 'new',
          label: 'How many total units?',
          name: 'newUnitCount',
          type: 'text',
          required: true,
          inputType: 'number',
          specialValidation: Joi.number().required(),
        },
        {
          cond: ({ intentToOrderType }) => intentToOrderType === 'new',
          label: 'Buyer Sheet, if any',
          name: 'newBuyerSheet',
          type: 'file',
          required: false,
        },
        {
          cond: ({ intentToOrderType }) => intentToOrderType === 'counter',
          label: 'Please add all counters we plan to add for the first order.',
          name: 'preliminaryPurchaseOrders',
          type: 'subForm',
          idKey: 'preliminary.styleDescription',
          buttonText: 'Add Counter',
          min: 1,
          subForm: {
            pageTitle: 'Counter',
            cards: [
              {
                title: 'Details',
                fields: [
                  {
                    label: 'Style number',
                    name: 'preliminary.styleNumber',
                    type: 'text',
                    inputType: 'number',
                    specialValidation: Joi.number().required(),
                    required: true,
                  },
                  {
                    label: 'Style name',
                    name: 'preliminary.styleDescription',
                    type: 'text',
                    required: true,
                  },
                  {
                    label: 'Current vendor',
                    name: 'preliminary.currentVendor',
                    type: 'text',
                    required: true,
                  },
                  {
                    label: 'Current unit cost',
                    name: 'preliminary.currentUnitCost',
                    type: 'text',
                    required: true,
                    inputType: 'number',
                    prefix: '$',
                    specialValidation: Joi.number().required(),
                  },
                  {
                    label: 'Current COO',
                    name: 'preliminary.currentCoo',
                    type: 'select',
                    required: true,
                    options: countries.map((country) => ({
                      label: country.text,
                      value: country.value,
                    })),
                  },
                  {
                    label: 'Proposed unit cost',
                    name: 'preliminary.proposedUnitCost',
                    type: 'text',
                    required: true,
                    inputType: 'number',
                    prefix: '$',
                    specialValidation: Joi.number().required(),
                  },
                  {
                    label: 'Proposed COO',
                    name: 'preliminary.proposedCoo',
                    type: 'select',
                    required: true,
                    options: countries.map((country) => ({
                      label: country.text,
                      value: country.value,
                    })),
                  },
                  {
                    label: 'Lead Time in number of weeks',
                    name: 'preliminary.leadTime',
                    type: 'text',
                    inputType: 'number',
                    required: true,
                    specialValidation: Joi.number().required(),
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
